<template>
<div class="homePage">
    <div class="actionBox">
        <el-button type="primary" @click="handleAdd">添加主页</el-button>
        <!--<div class="search">-->
            <!--<el-input placeholder="输入页面名称" v-model="param.pagename"></el-input>-->
            <!--<el-button @click="handleQuery">搜索</el-button>-->
        <!--</div>-->
    </div>

    <div class="pageList">
        <div class="listTitle">店铺主页列表(<span>{{tableData.length}}</span>条)</div>
        <div class="result-list btn-operate-list">
            <el-table :data="tableData" style="width: 100%">
                <el-table-column prop="pagename" label="主页名称" class-name="pageNameBox">
                    <template slot-scope="scope">
                        <div class="pageName">
                            <div class="homePage">
                                <div class="name">
                                    {{scope.row.name}}
                                </div>
                                <div class="pageTips" v-if="scope.row.isdefault">默认</div>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="statusText" label="状态" class-name="createTime">
                    <template slot-scope="scope">
                        <span :class="[scope.row.status?'tc-blue':'tc-red']">{{scope.row.statusText}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="memo" label="说明" class-name="createTime"></el-table-column>
                <el-table-column prop="address" label="操作" class-name="operation" width="300">
                    <template slot-scope="scope">
                        <div class="action" v-if="scope.row.status">
                            <div class="homepageAction">
                            <span v-if="!scope.row.isdefault">
                                <el-button @click="handleDefault(scope.row)" type="text" size="small">设为默认</el-button>
                                <span class="line">|</span>
                            </span>
                            <span>
                                <el-button @click="handleEditNav(scope.row)" type="text" size="small">设置导航</el-button>
                                <span class="line">|</span>
                            </span>
                            <span>
                                <el-button @click="handlePreview(scope.row)" type="text" size="small">预览</el-button>
                                <span class="line">|</span>
                            </span>
                            <span>
                                <Share :row='scope.row'></Share>
                            </span>
                                <span>
                                <el-button @click="handleDel(scope.row)" type="text" size="small">删除</el-button>
                            </span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
    <page :total='total' @getList="_getlist" ref="page"></page>
    <el-dialog title="新建主页" :visible.sync="dialogVisible" @close="cancel">
        <el-form :model="item" :rules="rules" ref="formName" label-width="110px" class="demo-item" label-position="left" size="mini">
            <el-form-item label="主页名称" prop="name">
                <el-input v-model.trim="item.name" placeholder="请输入主页名称" clearable maxlength="32" show-word-limit></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="submit">确 定</el-button>
        </span>
    </el-dialog>
    <shopHome ref="shopHome"></shopHome>
</div>
</template>
<script>
import Page from '@/base/page/page'
import {getHomePageList, editHomePageDefault, delHomePage, editShopNavigationMessage} from 'api/api'
import {mapGetters, mapActions} from 'vuex'
import {urlToQRCode, downloadImage} from 'common/js/tools'
import Share from '@/base/share/share'
import ShopHome from 'views/shopMgt/mob/page/components/shopHome.vue'
export default {
    name: 'homePage',
    data() {
        return {
            dialogVisible: false,
            total: 20,
            tableData: [],
            item: {
                name: '',
                clienttype: '1'
            },
            param: {
                pagename: ''
            },
            rules: {
                name: [
                    {required: true, message: '请输入主页名称', trigger: 'blur'},
                    {min: 1, max: 45, message: '长度在 1 到 32 个字符', trigger: 'blur'}
                ]
            }
        }
    },
    mounted() {
        this._getlist()
    },
    methods: {
        cancel () {
            this.item.name = ''
            this.$refs.formName.resetFields()
            this.dialogVisible = false
        },
        submit() {
            this.$refs.formName.validate((valid) => {
                if (valid) {
                    this.setLoading(true)
                    editShopNavigationMessage({
                        data: this.item,
                        success: data => {
                            this.cancel()
                            this.$message.success('保存成功！')
                            this.setLoading(false)
                            this._getlist()
                        },
                        error: data => {
                            this.$message.error(data.msg)
                            this.setLoading(false)
                        }
                    })
                }
            })
        },
        handleQuery() {
            this.$refs.page.handleSizeChange(1)
        },
        handleAdd() {
            this.item.name = ''
            this.dialogVisible = true
        },
        handleEditNav(row) {
            this.$router.push({name: 'ShopNav', query: {id: row.homeinnerid}})
        },
        handlePreview(row) {
            this.$refs.shopHome.openDialog(row)
        },
        handleDel(row) {
            this.setLoading(true)
            delHomePage({
                data: {
                    homeinnerid: row.homeinnerid
                },
                success: data => {
                    this.$message.success('删除成功！')
                    this.setLoading(false)
                    this._getlist()
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        download(imgsrc, name) { // 下载图片地址和图片名
            downloadImage(imgsrc, name)
        },
        onCopy(e) {
            this.$message({
                message: '复制成功',
                type: 'success'
            })
            console.log(e.text)
        },
        onError(e) {
            alert('失败')
        },
        handleDefault(row) {
            this.setLoading(true)
            editHomePageDefault({
                data: {
                    homeinnerid: row.homeinnerid
                },
                success: data => {
                    this.$message.success('设置店铺主页成功！')
                    this.setLoading(false)
                    this._getlist()
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        _getlist() {
            this.setLoading(true)
            getHomePageList({
                data: Object.assign({}, this.page, this.param),
                success: data => {
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                    this.tableData.forEach(obj => {
                        obj.qrShare = urlToQRCode(obj.shareurl)
                    })
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    computed: {
        ...mapGetters([
            'page',
            'permission'
        ])
    },
    components: {
        Page,
        Share,
        ShopHome
    }
}
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/base";
@import "~common/scss/mixin";
.homePage{
    .minPageTips{
        height: 50px;
        background: #F5F7FA;
        text-indent: 21px;
        line-height: 50px;
        font-size: 14px;
        span{
            color: #409EFF;
        }
    }
    .homepageBox{
        height: 72px;
        background: #F5F7FA;
        margin-top: 20px;
        padding-left: 28px;
        @include flexBox('');
        img{
            width: 48px;
            height: 48px;
            margin-right: 14px;
        }
        .rightText{
            flex: 1;
            .shopNameBox{
                @include flexBox(space-between);
                .shopName{
                    .shopHome{
                        background: #409EFF;
                        color: #fff;
                        display: inline-block;
                        width: 56px;
                        height: 18px;
                        text-align: center;
                        line-height: 18px;
                        margin-left: 10px;
                    }
                }
                .action{
                    padding-right: 30px;
                    color: #409EFF;
                    span:not(.line){
                        cursor: pointer;
                    }
                    .line{
                        margin: 0 10px;
                        position: relative;
                        top: -1px;
                        // cursor: none;
                    }
                }
            }
            .time{
                margin-top: 5px;
            }
        }
    }
    .actionBox{
        margin-top: 20px;
        @include flexBox(space-between);
        .search{
            .el-input{
                width: 240px;
            }
            .el-button{
                margin-left: 20px;
            }
        }
    }
    .pageList{
        margin-top: 20px;
        .el-table{
            margin-top: 11px;
            .pageNameBox{
                padding-left: 30px;
            }
            .pageName{
                .homePage{
                    @include flexBox('');
                    .pageTips{
                        background: #409EFF;
                        color: #fff;
                        width: 56px;
                        height: 18px;
                        line-height: 18px;
                        margin-left: 10px;
                        font-size: 12px;
                        text-align: center;
                    }
                }
            }
            .createTime{
                text-align: center;
            }
            .operation{
                text-align: right;
                .action{
                    color: #409EFF;
                    .homepageAction,.commonPageAction{
                        .line{
                            margin: 5px;
                            position: relative;
                            top: -1px;
                        }
                        span:not(.line){
                            cursor: pointer;
                        }
                    }
                }
            }
        }
    }
}
.el-popover{
    .microPage-pr-code-upload{
        text-align: center;
        img{
            width: 160px;
            height: 160px;
        }
        .pr-code-text{
            color: $tcolor-blue;
            padding: 20px 0;
        }
        .btn-operate{
            @include flexBox(space-between);
            .el-input,input{
                width: 210px;
                height: 36px;
                line-height: 36px;
            }
            .el-button{
                min-width: 60px;
            }
        }
    }
}
</style>
